import type {
  CreateMonthlyReportBody,
  ListMonthlyReportsQuery,
  ListMonthlyReportsResult,
  MonthlyReportDetail,
  UpdateMonthlyReportBody,
} from "@/modules/management/monthly-report/domain/types";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

const base = `${config.apiUrl}/management/monthly-reports`;

function buildQueryString(params: ListMonthlyReportsQuery): string {
  const search = new URLSearchParams();
  if (params.offset != null) search.set("offset", String(params.offset));
  if (params.limit != null) search.set("limit", String(params.limit));
  if (params.sort != null && params.sort.length > 0)
    search.set("sort", JSON.stringify(params.sort));
  if (params.periodYear != null) search.set("periodYear", String(params.periodYear));
  if (params.periodMonth != null)
    search.set("periodMonth", String(params.periodMonth));
  if (params.departmentId != null)
    search.set("departmentId", params.departmentId);
  if (params.search != null) search.set("search", params.search);
  const q = search.toString();
  return q ? `?${q}` : "";
}

export const monthlyReportApi = {
  list(query: ListMonthlyReportsQuery): Promise<ListMonthlyReportsResult> {
    return fetcher.get<ListMonthlyReportsResult>(
      `${base}${buildQueryString(query)}`,
    );
  },

  getById(id: string): Promise<MonthlyReportDetail> {
    return fetcher.get<MonthlyReportDetail>(
      `${base}/${encodeURIComponent(id)}`,
    );
  },

  create(body: CreateMonthlyReportBody): Promise<{ id: string }> {
    return fetcher.post<{ id: string }>(base, body);
  },

  update(
    id: string,
    body: UpdateMonthlyReportBody,
  ): Promise<{ ok: boolean }> {
    return fetcher.put<{ ok: boolean }>(
      `${base}/${encodeURIComponent(id)}`,
      body,
    );
  },

  delete(id: string): Promise<{ ok: boolean }> {
    return fetcher.delete<{ ok: boolean }>(
      `${base}/${encodeURIComponent(id)}`,
    );
  },

  /** Download URL for file stored by fileKey (no encoding - matches /files/ route which expects key with slashes) */
  getFileUrl(fileKey: string): string {
    return `${config.apiUrl}/files/${fileKey}`;
  },
};
